import { usePode } from '@/api/me';
import type { BuscaMargens } from '../tipos';
import { SecaoPraticadosPerderam } from './secao-praticados-perderam';
import { SecaoPropostasQueda } from './secao-propostas-queda';

/**
 * Os dois blocos de custo atualizado. Exigem `margens.ver` E `custo.ver` (a API responde 403 sem eles): sem a permissao
 * (ou enquanto o /me carrega) nao renderiza nada e nao chama a API.
 */
export function BlocoCustoAtualizado({ busca }: { busca: BuscaMargens }) {
  const { pode } = usePode();
  if (!(pode('margens.ver') && pode('custo.ver'))) return null;
  return (
    <div className="flex flex-col gap-5">
      <SecaoPropostasQueda busca={busca} />
      <SecaoPraticadosPerderam busca={busca} />
    </div>
  );
}
